<div class="grid" *ngIf="assignedTags$ | async as tags">
  <div class="grid__col-sm-10 grid__col-xs-12 center-item center-text">
    <h1 class="h1" tabindex="-1" dgxAutofocus>
      {{ title }}
      {{
        'Onboarding_AssignedSkillsHeader'
          | translate: { count: tags?.length, roleName: currentRoleTitle }
      }}
    </h1>
    <p class="par guts-p-t-1">
      {{
        'Onboarding_AssignedSkillsDescription'
          | translate: { currentRole: currentRoleTitle }
      }}
    </p>
  </div>
  <div class="grid__col-10 center-item guts-m-t-1">
    <ul class="inline-list center-text">
      <li
        *ngFor="let tag of tags"
        class="guts-m-r-1 guts-m-b-1"
        data-dgat="assigned-skills-dfd"
      >
        <button
          df-button
          type="button"
          class="btn btn__toggle"
          [ngClass]="{
            'df-button-primary': tag.isFollowing,
            'df-button-secondary': !tag.isFollowing
          }"
          (click)="onToggleTag(tag, tags)"
          role="checkbox"
          [attr.aria-checked]="tag.isFollowing"
          data-dgat="assigned-skills-eab"
        >
          <!-- a new Fresco action button coming in Future will
             replace need for v-bottom on these action buttons -->
          <df-icon
            *ngIf="tag.isFollowing"
            icon="checkmark"
            size="medium"
            class="v-bottom"
          ></df-icon>
          {{ tag.title | titlecase }}
        </button>
      </li>
    </ul>
    <div class="l_flex center-item">
      <df-local-notification
        *ngIf="showWarningSkillRemoved"
        class="block guts-m-t-1-half guts-m-h-1"
        size="large"
        [text]="i18n.Onboarding_AssignedSkillsWarning"
        icon="exclamation-circle"
        [type]="NotificationType.warning"
      ></df-local-notification>

      <df-local-notification
        *ngIf="showErrorNoSelectedSkills"
        class="block guts-m-t-1-half guts-m-h-1"
        size="large"
        [text]="i18n.Onboarding_AssignedSkillsError"
        icon="cross-circle"
        [type]="NotificationType.error"
      ></df-local-notification>
    </div>
  </div>
</div>
